/*
 * HAUS count-up utility.
 *
 * Animates any element marked data-haus-count from 0 to its own displayed
 * value the first time it scrolls into view. Fixed 3000ms duration for every
 * counter, same easing curve (ease-out-expo: fast start, long settle), so
 * bigger numbers move through more ground in the same window rather than
 * running longer. Number parsing keeps any prefix/suffix text (e.g. "+",
 * "%") and reapplies it every frame, and preserves thousands separators if
 * the source text has them. Skips animation entirely under
 * prefers-reduced-motion, showing the final value immediately.
 *
 * Usage: add data-haus-count to any element whose full text content is the
 * number to animate (plus optional prefix/suffix), e.g. <b data-haus-count>25+</b>.
 */
(function () {
  if (window.HausCountUp) return;
  window.HausCountUp = true;

  var DURATION = 3000;

  function easeOutExpo(t) {
    return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function parseTarget(text) {
    var match = text.match(/([\d,.]*\d)/);
    if (!match) return null;
    var raw = match[1];
    var prefix = text.slice(0, match.index);
    var suffix = text.slice(match.index + raw.length);
    var hasComma = raw.indexOf(',') !== -1;
    var dotIndex = raw.lastIndexOf('.');
    var decimals = dotIndex !== -1 ? raw.length - dotIndex - 1 : 0;
    var numeric = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(numeric)) return null;
    return {
      numeric: numeric,
      prefix: prefix,
      suffix: suffix,
      hasComma: hasComma,
      decimals: decimals
    };
  }

  function formatValue(value, parsed) {
    var v = parsed.decimals > 0 ? value.toFixed(parsed.decimals) : String(Math.round(value));
    if (parsed.hasComma) {
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      v = parts.join('.');
    }
    return parsed.prefix + v + parsed.suffix;
  }

  function animate(el, parsed, finalText) {
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      var t = Math.min(elapsed / DURATION, 1);
      var eased = easeOutExpo(t);
      if (t >= 1) {
        el.textContent = finalText;
        return;
      }
      el.textContent = formatValue(parsed.numeric * eased, parsed);
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init() {
    var els = document.querySelectorAll('[data-haus-count]');
    if (!els.length) return;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    els.forEach(function (el) {
      var finalText = el.textContent.trim();
      var parsed = parseTarget(finalText);
      if (!parsed || reduceMotion) return;

      el.textContent = formatValue(0, parsed);

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(el);
            animate(el, parsed, finalText);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
